import { AlertTriangle, Bell, Info, RotateCcw, X } from 'lucide-react';
import { Icon } from '@/core/ui/icons';
import { useToastStore } from './toastStore';

// The kind carries the glyph — message strings stay plain text (no emoji).
// Icons inherit the container's color: danger text on errors, ink otherwise.
const KIND_ICON = { info: Info, notify: Bell, error: AlertTriangle } as const;

export function Toast() {
  const message = useToastStore((s) => s.message);
  const kind = useToastStore((s) => s.kind);
  const action = useToastStore((s) => s.action);
  const clear = useToastStore((s) => s.clear);
  if (!message) return null;
  return (
    // Announced to screen readers — the toast is the ONLY signal that a save failed
    // or that an Undo is available, and without a live region it was silent.
    // assertive for errors (interrupt), polite for confirmations.
    <div
      role="status"
      aria-live={kind === 'error' ? 'assertive' : 'polite'}
      className="fixed bottom-5 left-1/2 z-[60] -translate-x-1/2 animate-fade-in"
    >
      <div
        onClick={() => { if (!action) clear(); }}
        className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3.5 py-2 text-sm shadow-lg ${
          kind === 'error' ? 'border-danger/40 bg-(--color-danger-tint) text-danger' : 'border-line bg-canvas text-ink'
        }`}
      >
        <Icon i={KIND_ICON[kind]} size={14} />
        {message}
        {action && (
          <button
            onClick={(e) => { e.stopPropagation(); action.run(); clear(); }}
            className="ml-1 flex items-center gap-1 rounded border border-brand/60 px-2 py-0.5 text-xs font-semibold text-brand hover:bg-brand/10"
          >
            {action.undo && <Icon i={RotateCcw} size={14} />}
            {action.label}
          </button>
        )}
        {action && (
          <button onClick={(e) => { e.stopPropagation(); clear(); }} className="text-faint hover:text-ink" title="Dismiss"><Icon i={X} size={14} /></button>
        )}
      </div>
    </div>
  );
}
